import React from 'react';
import './styles/table.css'; // Import the CSS file
import TableComponent from './TableComponent'

const FrequencyTableComponent = ({ freq_table, displaySettings }) => {
  const frequency=freq_table.freq_table;
  
  return (
    <div className="table-container">
      <h4>{freq_table.Qtitle}</h4>
<TableComponent
cols={frequency.cols} statements={frequency.rows} datavalue={frequency.datavalue}
lvl1={"colIndex"} lvl2={"rowIndex"} lvl3={"statementIndex"} lvl4={"ratingIndex"}
flt3={0} flt4={0}
displaySettings={displaySettings}
szr={!!freq_table.szr}
></TableComponent>    
{/* {JSON.stringify(frequency)} */}
    </div>
  );
};

export default FrequencyTableComponent;
